import { InvokeCreator } from "xstate";
import { logger } from "@/utils/logger";
import {
  fetchRepairedFileDownloadInfo,
  getFileToRepairUploadStatus,
  repairFile,
  uploadFileToRepair,
} from "@/services/fileRepairService";
import { IContext, IEvent } from "./types";

const UPLOAD_STATUS_POLLING_INTERVAL = 2_000;

export const uploadFileService: InvokeCreator<
  IContext,
  IEvent
> = ctx => send => {
  if (!ctx.file) {
    throw Error("Invalid context: file should not be null");
  }

  uploadFileToRepair(ctx.file)
    .then(fileName =>
      send({
        type: "SET_UPLOADED_FILE_NAME",
        fileName,
      }),
    )
    .catch(err => {
      logger.error("Failed to upload the file", err);
      throw err;
    });
};

export const fetchUploadStatusService: InvokeCreator<
  IContext,
  IEvent
> = ctx => send => {
  const { uploadedFileName } = ctx;
  if (!uploadedFileName) {
    throw Error("Invalid context: uploadedFileName should not be null");
  }

  const interval = setInterval(() => {
    getFileToRepairUploadStatus(uploadedFileName)
      .then(status => {
        send({
          type: "SET_UPLOAD_PROGRESS",
          status,
        });
      })
      .catch(err => {
        logger.error("Failed to fetch upload status", err);
        throw err;
      });
  }, UPLOAD_STATUS_POLLING_INTERVAL);

  return () => clearInterval(interval);
};

export const repairFileService: InvokeCreator<IContext, IEvent> = async (
  ctx,
): Promise<void> => {
  if (!ctx.uploadedFileName) {
    throw Error("Invalid state: ctx.uploadedFileName should not be null");
  }

  await repairFile(ctx.uploadedFileName);
};

export const fetchDownloadUrl: InvokeCreator<
  IContext,
  IEvent
> = ctx => send => {
  if (!ctx.uploadedFileName) {
    throw Error("Invalid state: ctx.uploadedFileName should not be null");
  }

  fetchRepairedFileDownloadInfo(ctx.uploadedFileName)
    .then(urls => {
      send({
        type: "SET_DOWNLOAD_URL",
        url: urls.repaired,
      });
    })
    .catch(err => {
      logger.error("Failed to fetch download info", err);
      throw err;
    });
};
